export default __webpack_public_path__ + "static/media/s13.960e62b3.png";